import PdfDownloadButton from "components/molecules/buttons/pdfDownload/pdfDownloadButton";

import { Form } from "components/organisms";
import { advanceLableInitialValue } from "components/organisms/forms/advance/advanceLabelForm";

import { useCustomParamId } from "hooks/useParamId";
import middleware from "middleware";
import { useTranslation } from "react-i18next";

import { useGetAdvanceDetail } from "services/advance/index";
import { IAdvance } from "services/advance/types";

const Advance = () => {
  const Id = useCustomParamId("id");

  const { t } = useTranslation();

  const advance = useGetAdvanceDetail(Id);

  const transformedData: IAdvance = advance.data
    ? middleware.advance.queryToForm(advance.data)
    : advanceLableInitialValue;

  const goToListPath = `advance`;

  return (
    <Form.AdvanceLabelForm
      isPending={advance.isLoading}
      i18nextPrefix="advance"
      initialValues={transformedData}
      status={{ displayMode: true }}
      onSubmit={() => {}}
      title={transformedData?.description}
      backPath={goToListPath ? goToListPath : ""}
      displayMode
      disable
      customBackItem
      topbarContent={<></>}
      disableTabs={[transformedData?.repaymentsFromAllContracts ? 1 : null]}
    />
  );
};

export default Advance;
